import React from 'react'
import { ActionIcon } from '@mantine/core'
import { IconBrandInstagram } from '@tabler/icons-react'

/**
 * Renders the Instagram link.
 * @param {string} url The Instagram URL.
 * @param {string} color The text color for the button.
 * @returns {JSX.Element}
 */
function InstagramIcon ({ url, color }) {
  return (
    <ActionIcon
      variant='filled'
      color={color}
      aria-label='Instagram'
      size='sm'
      component='a'
      href={url}
      target='_blank'
      autoContrast
    >
      <IconBrandInstagram stroke={2} aria-label='Follow on Instagram' />
    </ActionIcon>
  )
}

export default React.memo(InstagramIcon)
